
















































































import {Component, Mixins, Prop} from 'vue-property-decorator';
import placeholder from "lodash/fp/placeholder";

@Component({
    methods: {placeholder}
})
export default class ColumnTitleContent extends Mixins() {
    @Prop({required: true}) readonly tableItem!: any;
    @Prop({required: true}) readonly stringProperty!: string;
    @Prop({required: false, default: {}}) readonly editingStrings!: any;
    @Prop({required: false, default: 'TODO'}) readonly placeholderText!: string;
    @Prop({required: false, default: false}) readonly isViewOnlyMode!: boolean;

    handleStartStringEditing(id: number, value: string | null) {
        this.$emit('start-string-editing', id, value);
    };

    handleCancelStringEditing(id: number) {
        this.$emit('cancel-string-editing', id);
    };

    handleSaveString(id: number) {
        this.$emit('save-string', id);
    };

    copyToClipboard(text: string) {
        const el = document.createElement("textarea");
        el.value = text;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
    };
}
